// In production, use the Worker API URL
// In development, use localhost Worker dev server
const WORKER_URL = 'https://songbattle-worker.richard-heiland6.workers.dev';
const API_BASE = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' ? `${WORKER_URL}/api` : 'http://localhost:8787/api'
);

export async function searchSongs(query) {
  const response = await fetch(`${API_BASE}/spotify/search?q=${encodeURIComponent(query)}&limit=10`);
  if (!response.ok) throw new Error('Search failed');
  return response.json();
}

export async function getPoolSongs(poolId, count = 16) {
  const response = await fetch(`${API_BASE}/spotify/pool/${encodeURIComponent(poolId)}?count=${count}`);
  if (!response.ok) throw new Error('Pool fetch failed');
  return response.json();
}

export async function getPools() {
  const response = await fetch(`${API_BASE}/spotify/pools`);
  if (!response.ok) throw new Error('Failed to fetch pools');
  return response.json();
}

export async function createPool(name) {
  const response = await fetch(`${API_BASE}/spotify/pools`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name })
  });
  if (!response.ok) throw new Error('Failed to create pool');
  return response.json();
}

export async function deletePool(poolId) {
  const response = await fetch(`${API_BASE}/spotify/pools/${encodeURIComponent(poolId)}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete pool');
  return response.json();
}

export async function getPublicLobbies() {
  const response = await fetch(`${API_BASE}/lobbies`);
  if (!response.ok) throw new Error('Failed to fetch lobbies');
  return response.json();
}

export async function registerPublicLobby(data) {
  await fetch(`${API_BASE}/lobbies/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
}

export async function updatePublicLobby(data) {
  await fetch(`${API_BASE}/lobbies/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
}

export async function unregisterPublicLobby(roomCode) {
  await fetch(`${API_BASE}/lobbies/unregister`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roomCode })
  });
}

export async function getSpotifyLoginUrl() {
  const response = await fetch(`${API_BASE}/spotify/login`);
  if (!response.ok) throw new Error('Login failed');
  return response.json();
}

export { API_BASE };
